import { StatoAvanzamentoFieldsDtoTipologiaBloccoEnumListEnum } from '@api/client';
import i18n from '../i18n/i18n';

export interface MappedBillingOptions {
  mappedTipologiaBloccoEnumList: BillingOption[] | undefined;
}

export interface BillingOption {
  value: string | undefined;
  label: string | undefined;
  id: number | undefined;
}

export const mappedTipologiaBloccoEnumList: BillingOption[] = [
  // {
  //   value: StatoAvanzamentoFieldsDtoTipologiaBloccoEnumListEnum.ChiusoFinanziariamente,
  //   label: i18n.t('project-detail.billing-plan.block-typology-options.financially-closed'),
  // },
  {
    value: StatoAvanzamentoFieldsDtoTipologiaBloccoEnumListEnum.InApprovazioneDelCliente,
    label: i18n.t('project-detail.billing-plan.block-typology-options.for-customer-approval'),
    id: 2,
  },
  {
    value: StatoAvanzamentoFieldsDtoTipologiaBloccoEnumListEnum.InRedazioneDelPartner,
    label: i18n.t('project-detail.billing-plan.block-typology-options.in-partner-review'),
    id: 3,
  },
  {
    value: StatoAvanzamentoFieldsDtoTipologiaBloccoEnumListEnum.LavorazioniInCorso,
    label: i18n.t('project-detail.billing-plan.block-typology-options.work-in-progress'),
    id: 4,
  },
  {
    value: StatoAvanzamentoFieldsDtoTipologiaBloccoEnumListEnum.SalInviato,
    label: i18n.t('project-detail.billing-plan.block-typology-options.sent'),
    id: 7,
  },
  {
    value: StatoAvanzamentoFieldsDtoTipologiaBloccoEnumListEnum.SalApprovato,
    label: i18n.t('project-detail.billing-plan.block-typology-options.approved'),
    id: 8,
  },
  // {
  //   value: StatoAvanzamentoFieldsDtoTipologiaBloccoEnumListEnum.SalDelDelivery,
  //   label: i18n.t('project-detail.billing-plan.block-typology-options.delivery-sal'),
  // },
  // {
  //   value: StatoAvanzamentoFieldsDtoTipologiaBloccoEnumListEnum.VerificaCicloAttivo,
  //   label: i18n.t('project-detail.billing-plan.block-typology-options.active-cycle-check'),
  // },
];
